import {apiClient} from '../apiClient';
import {
  ICommExplorer,
  ExplorerRequest,
  FilterMetaDataPayload,
} from '../types/communicationExplorer.type';
import {ReportPayload} from '../../components/reports/communication-explorer/FilterHeader';
import BASE_URL from '../../config/env';
import {
  BackendErrorData,
  parseApiError,
} from '../../utils/custom-errors/parseApiError';
const REPORTING_BASE_URL = `${BASE_URL}/reporting/api/v1/dataanalysisreport/communication-explorer`;
const BASE_URL_SAVE = 'reporting/api/v1';

export interface ISavedReport {
  ReportID: string;
  ReportName: string;
  ReportType: 'Private' | 'Public';
  [key: string]: any;
}

export interface ISavedReportResponse {
  Data: ISavedReport[];
}

export interface ICommunicationMapReportPayload {
  selectionCriteria: any;
  actionType: 'SAVEREPORT';
  reportType: string;
  reportName: string;
  updateOrCreate: boolean;
  reportId: string | number;
  filters: any[];
}

export interface ICommunicationDataFilter {
  projectFieldId: string;
  projectFieldName: string;
  dataType: string;
  projectFieldLabel: string;
  type: number;
  operand: string;
  values: string[];
  metaDataID: number;
  text: string;
}

export interface IFlowChartNode {
  id: number;
  name: string;
  sentCount: number;
  recievedCount: number;
  isRemainig: boolean;
  x: number;
  y: number;
  radius: number;
  exchangeCount: number;
}

export interface IFlowChartLink {
  fromNodeID: number;
  toNodeID: number;
  fromCount: number;
  toCount: number;
  volume: number;
  connectorExchangeCount: number;
}

export interface IExchangeDocs {
  totalExchangeDocs: number;
  filtersDomains: number;
  filtersEmailsAddress: number;
  nonEmailDocs: number;
}

export interface IConnector {
  from: string;
  to: string;
  fromNodeID: number;
  toNodeID: number;
}

export interface ICommunicationLiteralValue {
  projectFieldName: string;
  values: string[];
}

export interface IFlowChart {
  node: IFlowChartNode[];
  link: IFlowChartLink[];
  exchangeDocs: IExchangeDocs[];
  connector: IConnector[];
  communicationLiteralValue: ICommunicationLiteralValue[];
}

export interface ICommunicationDataRequest {
  sourceName: string;
  source: string[];
  filters: ICommunicationDataFilter[];
  showByCount: string;
  showBy: string;
  showByVolume: string;
  flowChart: IFlowChart;
  reportId: string;
  isDocumentCount: boolean;
  totalDocumentToView?: number;
}

export interface IBulkCommunicationReportRequest
  extends ICommunicationDataRequest {
  actionFrom: string;
  navigateTo: string;
  prepareList: boolean;
}

export interface IBulkCommunicationReportResponse {
  isDocumentCount: boolean;
  documentCount: number;
  docListId: string;
  generatedAt: string;
  reportMasterDoclistId: string | null;
  source: any;
}

export interface IFilterByMetaData {
  fieldID: string;
  fieldName: string;
  literalValue: string;
  fieldType: string;
}

export interface ICommunicationDataResponse {
  sourceType: string;
  sourceID: string[];
  docListID: number;
  filterByMetaData: IFilterByMetaData[];
  flowChart: IFlowChart;
  isBulkAction: boolean;
  showByCount: string;
  showBy: string;
  showByVolume: string;
  reportName: string;
  dataAsOf: string;
  isDocumentCount: boolean;
  documentCount: number;
  totalDocumentToView: number;
  navigationSourceType: string;
  communicationLiteralValue: ICommunicationLiteralValue[];
  isShared: boolean;
  isSavedSearchSource: boolean;
}

const settingsEndpoint = (path: string) =>
  `/reporting/api/v1/dataanalysisreport${path}`;

export const getMetaDataFilter = async (payload: FilterMetaDataPayload) => {
  const {data} = await apiClient.get<any>(
    `documentmanagement/api/v1/metadatafilters/getmetadatafilter`,
    {params: payload}
  );
  return data ?? [];
};

export const getCommunicationExplorerData = async (payload: ICommExplorer) => {
  const {data} = await apiClient.get<any>(
    settingsEndpoint('/communication-explorer'),
    {params: payload}
  );
  return data;
};
export const CommunicationExploreView = async (
  payload: ExplorerRequest
): Promise<string> => {
  const response = await apiClient.post<string>(
    `${REPORTING_BASE_URL}/view`,
    payload,
    {
      headers: {
        accept: 'text/plain',
        'Content-Type': 'application/json',
      },
    }
  );
  return response.data;
};

export const postCommunicationReport = async (payload: ReportPayload) => {
  const {data} = await apiClient.post<any>(
    `${REPORTING_BASE_URL}/save`,
    payload
  );
  return data;
};

export const getSavedReports = async (
  reportTypeCode: string
): Promise<ISavedReportResponse> => {
  const response = await apiClient.get(
    `${BASE_URL_SAVE}/report/reportlist/saved-report`,
    {
      params: {reportTypeCode},
    }
  );

  return response.data;
};

export const saveCommunicationMapReport = async (
  payload: ICommunicationMapReportPayload
): Promise<any> => {
  const {data} = await apiClient.post(
    `${BASE_URL_SAVE}/sharereports/savecommunicationmapreportxml`,
    payload
  );
  return data;
};

export const postCommunicationData = async (
  payload: ICommunicationDataRequest
): Promise<ICommunicationDataResponse> => {
  const {data} = await apiClient.post<ICommunicationDataResponse>(
    settingsEndpoint('/communication-data'),
    payload
  );
  return data;
};

export const postBulkCommunicationReport = async (
  payload: IBulkCommunicationReportRequest
): Promise<IBulkCommunicationReportResponse> => {
  const {data} =
    await apiClient.post<IBulkCommunicationReportResponse>(
      settingsEndpoint('/bulk-communication-report'),
      payload
    );
  return data;
};

export const postCommunicationBulkReport = async (
  payload: any
): Promise<any> => {
  const {data} = await apiClient.post<any>(
    settingsEndpoint('/communication/bulk-report'),
    payload
  );
  return data;
};
